import React, { useState } from 'react';
import { apiPost } from '../utils/api';

const MacLookup = () => {
  const [mac, setMac] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLookup = async () => {
    if (!mac.trim()) return;
    setLoading(true);
    setResult(null);
    try {
      const data = await apiPost('/api/mac/lookup', { mac });
      setResult(data);
    } catch (e) {
      setResult({ error: 'Erro ao consultar MAC Address.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-gray-900">Consulta de MAC Address</h2>
      <p className="mb-4 text-gray-600">Digite um endereço MAC para descobrir o fabricante (exemplo: 00:1A:2B:3C:4D:5E)</p>
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={mac}
          onChange={e => setMac(e.target.value)}
          placeholder="00:1A:2B:3C:4D:5E"
          className="flex-1 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          onClick={handleLookup}
          disabled={loading || !mac.trim()}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
        >
          {loading ? 'Consultando...' : 'Consultar'}
        </button>
      </div>
      {result && (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg">
          {result.error ? (
            <span className="text-red-500">{result.error}</span>
          ) : (
            <>
              <div><b>MAC:</b> {result.mac}</div>
              <div><b>Fabricante:</b> {result.vendor}</div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MacLookup; 